import React from 'react'
import {Col, Row} from 'antd'
import PropTypes from 'prop-types'

//Components
import TextField from '../../Common/ViewField'

// Constant
import typo from '../../../constants/dictionaries'
import helper from '../../../helper/helper'
import {RowTableDetail, TableDetail} from "../../Common/View/TableViewDetail";
import constant from '../../../constants/constant'
import DateView from "../../Common/View/DateView";
import TTKT from "../../AttachTable/TTKT/Table";
import Container from "../../../containers/Container";

const TTDuAndetail = ({data}) => {
  const {
    tenDuAn,
    diaChi,
    phamVi_QuyMo,
    truLuongKhaiThac,
    truLuong_DonVi_Ten,
    congSuatThietKe,
    congSuat_DonVi_Ten,
    ghiChu,

  } = data || {};
  return (
    <Row>
       <TableDetail>
           
        
        <RowTableDetail title={typo.input_tenduan}>{tenDuAn}</RowTableDetail>
        <RowTableDetail title={typo.cscore_input_address}>{diaChi}</RowTableDetail>
        <RowTableDetail title={typo.cscore_input_phamviquymo}>{phamVi_QuyMo}</RowTableDetail>
        <RowTableDetail title={typo.cscore_inout_truluongkt}>{truLuongKhaiThac}</RowTableDetail>
        <RowTableDetail title={typo.cscore_donvitruluong}>{truLuong_DonVi_Ten}</RowTableDetail>
        <RowTableDetail title={typo.cscore_input_cskt}>{congSuatThietKe}</RowTableDetail>
        <RowTableDetail title={typo.cscore_coongsuatkt}>{congSuat_DonVi_Ten}</RowTableDetail>
        <RowTableDetail title={typo.cscore_ghiChu}>{ghiChu}</RowTableDetail>
        {/*<RowTableDetail title={typo.cscore_license_place_received}>{noiNhan}</RowTableDetail>*/}
      </TableDetail>
    </Row>
  )
};

TTDuAndetail.propTypes = {
  data: PropTypes.any.isRequired,
};

export default TTDuAndetail
